import { Text } from "@fluentui/react";

import Layout from "components/Layout";
import SEO from "components/Seo";
import Resource from "./components/Resource";

export const Home = () => {
  const banner = (
    <div
      className="hero"
      style={{
        background: "url(./images/DataLake-min_1-scaled.webp)",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        height: "650px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start",
        boxShadow: "inset 680px 0 173px -4px rgb(0 0 0 / 20%)"
      }}
    >
      <div className="grid-content">
        <Text
          block
          variant="mega"
          className="title"
          styles={{
            root: {
              color: "#fff",
              maxWidth: 580,
              marginBottom: 40,
              fontWeight: "bold",
            },
          }}
        >
          Destination Earth Data Lake
        </Text>
      </div>
    </div>
  );

  return (
    <Layout bannerHeader={banner}>
      <SEO title="Home" />
      <div
        className="grid-content"
        style={{
          display: "flex",
          flexFlow: "column nowrap",
          alignItems: "center",
          marginTop: "80px",
        }}
      >
        <Text
          block
          variant="xxLarge"
          style={{ textAlign: "center", maxWidth: "550px" }}
        >
          Seamless data access and processing for enhanced decision-making
        </Text>
        <Text
          block
          variant="large"
          style={{ margin: "1.8rem 0", textAlign: "center", maxWidth: "815px" }}
        >
          The DestinE Data Lake (DEDL) provides discovery, access, and big data processing
          services. It provides a seamless access to datasets via GUIs or APIs to data, in
          accordance to the DestinE Data Portfolio, regardless of data type and location.
        </Text>
        <img src="./images/datatype.png" style={{ maxWidth: "100%" }}></img>
        <Text
          block
          variant="large"
          style={{ margin: "1.8rem 0", textAlign: "center", maxWidth: "815px" }}>
          The DestinE Data Portfolio evolves according to user needs and follows a defined
          and evolving process for enhancements, which takes into account required data
          storage needs. The DEDL big data processing allows near-data processing and by
          this conceptually supports ML/AI applications executed on the DEDL. The DestinE
          data lake federates with existing data holdings as well as with complementary
          data from diverse sources like in-situ, socio-economic, or data-space data.
        </Text>
        <Text
          block
          variant="large"
          style={{ marginTop: "1.8rem", textAlign: "center", maxWidth: "815px" }}>
          The Data Lake is operated by the European Organisation for the Exploitation
          of Meteorological Satellites (EUMETSAT).
        </Text>
      </div>
      <div className="home-resources layout-container">
        <div
          className="grid-content"
          style={{
            display: "flex",
            flexFlow: "column nowrap",
            alignItems: "center",
            marginBottom: "100px",
          }}
        >
          <Text
            block
            variant="xxLarge"
            style={{ textAlign: "center", maxWidth: "550px", paddingTop: "14px" }}
          >
            Partners
          </Text>
        </div>
        <div className="layout-row grid-content">
          <Resource
            title="Visit EUMETSAT"
            href="https://www.eumetsat.int/"
            imageSrc="./images/eumetsat_logo.svg"
            external
          >
            We are the European Organisation for the Exploitation of Meteorological 
            Satellites
          </Resource>
          <Resource
            title="Visit CloudFerro"
            imageSrc="./images/cloudferro-logo.svg"
            href="https://cloudferro.com/"
            external
          >
            CloudFerro provides next generation cloud services dedicated to specific 
            domains and industries.
          </Resource>
          <Resource 
            title="Visit CS Group"
            imageSrc="./images/CS-GROUP.svg"
            href="https://www.csgroup.eu/en/"
            external
          >
            Our specialization is to design information and communication systems tailored 
            to our clients operational requirements
          </Resource>
          <Resource
            title="Visit EODC"
            imageSrc="./images/EODC-Logo-Final.webp"
            href="https://eodc.eu/"
            external
          >
            We assist our partners and customers with our expertise in earth observation 
            (EO) and information technology (IT) to create current and future-oriented 
            benefits for society and environment.
          </Resource>
        </div>
      </div>
    </Layout>
  );
};
